import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'

import type SelectOptGroup from './select-opt-group.vue'
import type SelectOption from './select-option.vue'
import type Select from './select.vue'

export const selectProps = buildProps({
  //  是否灰色样式
  isGray: {
    type: Boolean,
    default: false,
  },
  //  最多显示多少个 tag
  maxTagCount: {
    type: Number,
    default: null,
  },
  // 最大显示的 tag 文本长度
  maxTagTextLength: {
    type: Number,
    default: null,
  },
})
export const selectOptionProps = buildProps({
  class: String,
  disabled: {
    type: String,
    default: false,
  },
  key: String,
  title: String,
  value: {
    type: definePropType<string | number>([String, Number]),
  },
})

export const selectOptGroupProps = buildProps({
  key: String,
  label: {
    type: String,
    default: '',
  },
})

// props
export type SelectProps = ExtractPropTypes<typeof selectProps>

export type SelctOptionProps = ExtractPropTypes<typeof selectOptionProps>

export type SelectOptGroupGroupProps = ExtractPropTypes<
  typeof selectOptGroupProps
>

// instance
export type SelectInstance = InstanceType<typeof Select>

export type SelectOptionInstance = InstanceType<typeof SelectOption>

export type SelectOptGroupInstance = InstanceType<typeof SelectOptGroup>
